import { BASE_URL } from "../../../Constant";

export const API_SERVICES_LOAD_BY_BUSINESS_ID: string = BASE_URL + '/api/service/businessId/'
export const API_SERVICE_FETCH_ALL: string = `${BASE_URL}/api/service/fetchAll`;
export const API_SERVICE_UPDATE: string = `${BASE_URL}/api/service`;
export const API_SERVICE_SAVE: string = `${BASE_URL}/api/service`;
export const API_SERVICE_LOAD_BY_ID: string = `${BASE_URL}/api/service/`;
export const API_SERVICE_ACTIVATE: string = `${BASE_URL}/api/service/activate`;


export const SERVICE_ACTIVE_STATUS: number = 1;
export const SERVICE_INACTIVE_STATUS: number = 7;
